import gsap from 'gsap';
import imagesLoaded from 'imagesloaded';
import RytmWebflow from 'rytm-webflow'

import { classNames } from '../constants';

class LazyImagesController extends RytmWebflow.Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e);
    setTimeout(this.updateLazyImages, 200);
  }
  addEventListeners() {
    super.addEventListeners();
    window.addEventListener('resize', this.onWindowEvent);
    window.addEventListener('orientationchange', this.onWindowEvent);
    window.addEventListener('scroll', this.updateLazyImages);
  }
  removeEventListeners() {
    super.removeEventListeners();
    window.removeEventListener('resize', this.onWindowEvent);
    window.removeEventListener('orientationchange', this.onWindowEvent);
    window.removeEventListener('scroll', this.updateLazyImages);
  }
  // ### Custom ###
  onWindowEvent = (e) => {
    clearTimeout(this.lazyImagesTimeout);
    this.lazyImagesTimeout = setTimeout(() => {
      this.updateLazyImages();
    }, 100);
  }
  updateLazyImages = () => {
    const list = [...document.querySelectorAll(`.${classNames.LAZY_IMAGE}`)];
    list.forEach(this.updateLazyImage);
  }
  updateLazyImage = (el) => {
    if (RytmWebflow.elementIsVisibleInViewport(el)) {
      this.loadImage(el);
    }
  }
  loadImage = (el) => {
    if (el.classList.contains(classNames.LAZY_IMAGE_LOADED)
      || el.classList.contains(classNames.LAZY_IMAGE_LOADING)) {
      return;
    }
    el.classList.add(classNames.LAZY_IMAGE_LOADING);
    const listSources = [...el.querySelectorAll('source')];
    listSources.forEach((source) => {
      source.srcset = source.dataset.srcset;
    });
    const img = el.querySelector('img');
    if (img) {
      img.onload = () => {
        el.classList.add(classNames.LAZY_IMAGE_LOADED);
        el.classList.remove(classNames.LAZY_IMAGE_LOADING);
        el.classList.remove("visually-hidden");
        gsap.fromTo(img, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.5 });
      };
      img.src = img.dataset.src;
    }
    
  }

}

export default LazyImagesController;